//---------------------------------------------------
//  Nom du fichier : Background.js 
//
//  Description: Component background qu'on met derrière 
//               les component qu'on veut fermer en cliquant ailleur
//               
//  Auteur: Alek Del Balso
//---------------------------------------------------

import './background.css';

function Background({children, func, open = true, style = null}) {
    if(open){
        return (
            <div 
            className='background_publication' 
            style={style}
            // je vérifie que le target est le background
            onMouseDown={(e) => {if(e.target == e.currentTarget) func()}}>
                {children}
            </div>
        );
    }
    else{
        return (<>{children}</>)
    }
  }
  
  export default Background;